import { ProjectLists } from './project-lists';
import { SidebarCollapsibleSection } from 'components/blocks/layout/sidebar-section';
import { useState } from 'react';
import { NewProjectModal } from './new-project-modal';
import { useQueryClient } from '@tanstack/react-query';
import { refetchProject } from '../helpers/query-utils';
import { useTranslation } from 'react-i18next';
import { AgentGroupBy } from 'components/blocks/layout/agents-group-menu';
// import { useChatStore } from 'state/store/chat/use-chat-store';

type ProjectsSectionProps = {
    variant?: 'default' | 'section';
    groupBy?: AgentGroupBy;
    onGroupByChange?: (value: AgentGroupBy) => void;
};

export const ProjectsSection = ({
    variant = 'section',
    groupBy,
    onGroupByChange,
}: ProjectsSectionProps) => {
    const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    // const removeConversationFromSidebarById = useChatStore((state) => state.removeConversationFromSidebarById);

    return (
        <div className="mb-0">
            <SidebarCollapsibleSection
                title={t("PROJECTS_TITLE", "Projects")}
                addLabel={t('NEW_PROJECT', 'New project')}
                onAddClick={() => setIsAddProjectModalOpen(true)}
                variant={variant}
                defaultOpen
                groupBy={groupBy}
                onGroupByChange={variant === 'section' ? onGroupByChange : undefined}
            >
                <div className="flex flex-col gap-1">
                    <ProjectLists variant={variant} />
                </div>
            </SidebarCollapsibleSection>

            <NewProjectModal
                callback={() => {
                    refetchProject(queryClient, '');
                }}
                isOpen={isAddProjectModalOpen}
                onClose={() => setIsAddProjectModalOpen(false)}
            />
        </div>
    );
}